import React, { createContext, useState, useEffect, useMemo, useCallback, FC } from "react"
import { ViewModeContextState } from './ViewModeTypes'

const defaultState: ViewModeContextState = {
    readOnly: false
}

export const ViewModeContext = createContext<ViewModeContextState>(defaultState)

const { Provider, Consumer } = ViewModeContext

export const ViewModeProvider = (props) => {
    const value = useMemo(() => ({
        readOnly: props.readOnly
    }), [props.readOnly])
    return (
        <Provider value={value}>
            {props.children}
        </Provider>
    )
}